import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-203a416e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex-1f page d-flex-column" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = {
  key: 0,
  class: "goods d-flex"
}
const _hoisted_4 = { class: "d-flex-1f my-swipe" }
const _hoisted_5 = { class: "d-flex-1f d-overflow" }
const _hoisted_6 = { class: "list-wrapper" }
const _hoisted_7 = { class: "list" }
const _hoisted_8 = { class: "d-relative d-flex-1f data-wrap" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "分类筛选", -1))
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item")!
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_ShopCard = _resolveComponent("ShopCard")!
  const _component_app_list = _resolveComponent("app-list")!
  const _component_shop_cart = _resolveComponent("shop-cart")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_van_dropdown_menu, { "active-color": "#FD5C02" }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_component_van_dropdown_item, {
              key: _ctx.state.value,
              modelValue: _ctx.state.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.value) = $event)),
              options: _ctx.option,
              onChange: _ctx.onChange
            }, null, 8, ["modelValue", "options", "onChange"]))
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_van_search, {
        shape: "round",
        class: "search d-flex-1f",
        placeholder: _ctx.state.text,
        onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push(`/shop/page/search`)))
      }, null, 8, ["placeholder"])
    ]),
    (_ctx.state.tagList)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_tabs, {
              onChange: _ctx.changeTab,
              active: _ctx.active,
              "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.active) = $event)),
              swipeable: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_tab, {
                  style: {"padding-left":"0px"},
                  name: "0",
                  title: "综合"
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.tagList, (item, index) => {
                  return (_openBlock(), _createBlock(_component_van_tab, {
                    name: item.id,
                    key: index,
                    title: item.value
                  }, null, 8, ["name", "title"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["onChange", "active"])
          ]),
          _createElementVNode("div", {
            class: "more",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.filter && _ctx.filter(...args)))
          }, [
            _createTextVNode(" 筛选 "),
            _createVNode(_component_van_icon, {
              name: "filter-o",
              color: "#8E8E8E"
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_app_list, {
        class: "appList",
        ref: "appList",
        triggerLoad: false,
        onLoadData: _cache[4] || (_cache[4] = (event) => _ctx.LoadData(event, _ctx.item)),
        emptyText: "没找到相关商品或服务哦~"
      }, {
        default: _withCtx((slotProps) => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.list, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item",
                  key: item
                }, [
                  _createVNode(_component_ShopCard, {
                    data: item,
                    home: 0
                  }, null, 8, ["data"])
                ]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }, 512),
      _createElementVNode("div", {
        onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToCart && _ctx.goToCart(...args)), ["stop"])),
        class: "cart"
      }, [
        _createVNode(_component_shop_cart, { ref: "cart" }, null, 512)
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.show,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.show) = $event)),
      closeable: "",
      "close-icon": "close",
      position: "right",
      style: { width: '60%', height: '100%' },
      onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.close()))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.tagArr, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: _normalizeClass([{ isCancel: item.show }, "data-item"]),
              onClick: ($event: any) => (_ctx.itemClick(item, index))
            }, _toDisplayString(item.value), 11, _hoisted_10))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}